import styles from '../../css/Privacy.module.css';

function PrivacyPolicy() {
  return (
    <main className="centeredHorizontallyOnMobile">
      <div className={styles.contentContainer}>
        <h1 className={styles.pageTitle}>Privacy Policy</h1>

        <p className={styles.lastUpdated}>
          Last updated: <time dateTime="2025-07-26">26 July 2025</time>
        </p>

        <p>Your privacy is important. This policy explains how information is collected and used when you visit or make a purchase on my website.</p>

        <hr className={styles.divider} />

        <h2 className={styles.sectionTitle}>1. Information I Collect</h2>

        <p>
          I do not collect any personal information directly on this website. Any personal data I may receive, such as your email address or name if you contact me directly or through my contact form, will be used solely for the purpose of responding to your inquiry. However, the following third-party services may collect data:
        </p>

        <div className={styles.subSectionTitle}>a. Stripe</div>

        <p>
          When you make a purchase, your payment and billing information is securely processed by Stripe. I do not see or store any credit card numbers or personal financial details.
        </p>

        <p>Stripe may collect:</p>
        <ul className={styles.bulletList}>
          <li>Name, email, billing address (for receipts and tax purposes)</li>
          <li>Payment details (handled securely by Stripe, such as card type and the last four digits of your card for transaction identification, though full card numbers are never visible to me)</li>
        </ul>

        <p>
          Please refer to <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer" aria-label="Stripe&apos;s privacy policy (opens in new tab)">Stripe&apos;s Privacy Policy</a> for full details.
        </p>

        <div className={styles.subSectionTitle}>b. Google Analytics</div>

        <p>
          This site uses Google Analytics with <strong>IP anonymization</strong> enabled to help me understand how visitors interact with the site—such as which pages are viewed or how long visitors stay. This data is anonymized and does not include personal information or identity.

          You can opt out of Google Analytics tracking using Google&apos;s official <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer" aria-label="Google Analytics opt-out browser add-on (opens in new tab)">Google Analytics opt-out browser add-on</a>.
        </p>

        <hr className={styles.divider} />

        <h2 className={styles.sectionTitle}>2. How Your Information Is Used</h2>

        <ul className={styles.bulletList}>
          <li>To process transactions securely via Stripe</li>
          <li>To understand and improve user experience on my site via Google Analytics</li>
        </ul>

        <p>I do not:</p>
        <ul className={styles.bulletList}>
          <li>Sell or share your personal information</li>
          <li>Send marketing emails unless you explicitly opt in on this website or elsewhere</li>
        </ul>

        <hr className={styles.divider} />

        <h2 className={styles.sectionTitle}>3. Cookies</h2>

        <p>
          Google Analytics uses <strong>performance/analytics</strong> cookies to track anonymous usage data, helping me understand site traffic and user behavior. These cookies are essential for the functionality of Google Analytics.

          You can disable cookies in your browser settings if you prefer. Please note that disabling cookies may affect the functionality of some websites.
        </p>

        <hr className={styles.divider} />

        <h2 className={styles.sectionTitle}>4. Third-Party Services</h2>

        <p>This site integrates with the following third parties:</p>
        <ul className={styles.bulletList}>
          <li>Stripe for secure checkout</li>
          <li>Google Analytics for anonymized usage tracking</li>
        </ul>

        <p>
          Each of these services may collect and store data as per their own privacy policies.
        </p>

        <hr className={styles.divider} />

        <h2 className={styles.sectionTitle}>5. Your Rights</h2>

        <p>
          Depending on where you live, you may have rights under laws like the GDPR (General Data Protection Regulation) or CCPA (California Consumer Privacy Act) to access, rectify, erase, restrict processing, object to processing, and data portability regarding your personal information. If you have any questions or concerns, or wish to exercise these rights, please contact me directly at <a href="mailto:luolawrence1@gmail.com">luolawrence1@gmail.com</a>.
        </p>

        <hr className={styles.divider} />

        <h2 className={styles.sectionTitle}>6. Changes to This Policy</h2>

        <p>This policy may be updated occasionally. The most current version will always be available on this page.</p>
      </div>
    </main>
  );
}

export default PrivacyPolicy;